export const seasons = [
  '9394',
  '9495',
  '9596',
  '9697',
  '9798',
  '9899',
  '9900',
  '0001',
  '0102',
  '0203',
  '0304',
  '0405',
  '0506',
  '0607',
  '0708',
  '0809',
  '0910',
  '1011',
  '1112',
  '1213',
  '1314',
  '1415',
  '1516',
  '1617',
  '1718',
  '1819',
  '1920',
  '2021',
];

export const seasonIdx = {
  9394: 0,
  9495: 1,
  9596: 2,
  9697: 3,
  9798: 4,
  9899: 5,
  9900: 6,
  '0001': 7,
  '0102': 8,
  '0203': 9,
  '0304': 10,
  '0405': 11,
  '0506': 12,
  '0607': 13,
  '0708': 14,
  '0809': 15,
  '0910': 16,
  1011: 17,
  1112: 18,
  1213: 19,
  1314: 20,
  1415: 21,
  1516: 22,
  1617: 23,
  1718: 24,
  1819: 25,
  1920: 26,
  2021: 27,
};
